import { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const formatDateTimeLocal = (utcDate) => {
  if (!utcDate) return "";

  const date = new Date(utcDate);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
export const toUtcISOString = (value) => {
  if (!value) return null;

  return new Date(value).toISOString();
};
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkToken = () => {
    const token = sessionStorage.getItem("token");
    if (!token) return false;
    try {
      const decoded = jwtDecode(token);
      const expired = Date.now() > decoded.exp * 1000;
      if (expired) {
        sessionStorage.removeItem("token");
        setIsAuthenticated(false);
        return false;
      }
      return true;
    } catch (error) {
      console.error("Invalid token:", error);
      sessionStorage.removeItem("token");
      setIsAuthenticated(false);
      return false;
    }
  };
  const userDetail = () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      setIsAuthenticated(false);
      return null;
    }
    try {
      const decoded = jwtDecode(token);
      return decoded;
    } catch (error) {
      console.error("Error decoding token:", error);
      setIsAuthenticated(false);
      return null;
    }
  };
  const login = (token) => {
    try {
      const decoded = jwtDecode(token);
      const expired = Date.now() > decoded.exp * 1000;
      if (expired) {
        console.warn("Trying to login with an expired token");
        setIsAuthenticated(false);
        return false;
      } else {
        sessionStorage.setItem("token", token);
        setIsAuthenticated(true);
        setLoading(false);
        return true;
      }
    } catch (error) {
      console.error("Invalid token on login:", error);
      sessionStorage.removeItem("token");
      setIsAuthenticated(false);
      return false;
    }
  };
  const logout = () => {
    sessionStorage.removeItem("token");
    setIsAuthenticated(false);
    setLoading(false);
  };
  useEffect(() => {
    setIsAuthenticated(checkToken());
    setLoading(false);
  }, []);
  return (
    <AuthContext.Provider
      value={{ isAuthenticated, login, logout, userDetail, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default function useAuthContext() {
  return useContext(AuthContext);
}
